import { IApiActionTypes } from "action/interfaces/api.interface";

export interface IAPIReducer {
  [key: string]: any,
}

const initlaState: IAPIReducer = {
  productDeliveryMethodDetails: { },
};

const apiReducer = (state = initlaState, action: IApiActionTypes): IAPIReducer => {
  switch (action.type) {
  case "SET_API_RESPONSE":
    return { ...state, [action.functionName]: action.data };
  case "SET_PRODUCT_DELIVERY_METHOD_DETAILS":
    const productMap = action.data.reduce((acc, curr) => {
      const { sku, ...rest } = curr;
      return {
        ...acc,
        [sku]: {
          ...rest,
        },
      };
    }, {});
    return { ...state, productDeliveryMethodDetails: productMap };
  default:
    return state;
  }
};

export default apiReducer;
